import { appColors } from '@/src/theme'
import { Box, Checkbox, type ComponentWithAs, FormControl, FormLabel, type FormLabelProps, Icon, type IconProps } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { WEEK_DAYS_OPTIONS } from '@utils/constants'

interface FormWeekDaySelectProps {
  values: Array<string>
  handleChange: (value: Array<string>) => void
  label: string
  labelProps?: FormLabelProps & { marginBottom?: string }
  isDisabled?: boolean
  isRequired?: boolean
}

const CustomCheckbox = styled(Checkbox)`
  border: none;

  & > span.chakra-checkbox__control[data-checked] {
    background-color: ${appColors.accentPrimary};
  }

  & > span.chakra-checkbox__control {
    background-color: #f9fafb;
    width: 32px;
    height: 28px;
    border-radius: 8px;
  }
`

const CustomCheckboxIcon: ComponentWithAs<'svg', IconProps & { label: string; isChecked?: boolean }> = ({
  label,
  isChecked = false,
  ...props
}) => {
  return (
    <Icon viewBox='0 0 20 20' {...props} height='20px' width='20px' opacity={1}>
      <text fontSize='14px' x='50%' y='56%' dominantBaseline='middle' textAnchor='middle' fill={isChecked ? 'white' : 'black'}>
        {label}
      </text>
    </Icon>
  )
}

export const FormWeekDaySelect = ({ values, handleChange, label, labelProps, isDisabled, isRequired }: FormWeekDaySelectProps) => {
  return (
    <FormControl isRequired={isRequired}>
      <FormLabel {...labelProps}>{label}</FormLabel>
      <Box
        display='flex'
        justifyContent={'space-between'}
        borderWidth={'1px'}
        borderColor={appColors.border}
        borderRadius={'8px'}
        paddingX={'2px'}
        paddingY={'0px'}
        width='80%'
      >
        {WEEK_DAYS_OPTIONS.map(item => {
          return (
            <CustomCheckbox
              isChecked={values.includes(item.value)}
              key={item.value}
              value={item.value}
              icon={<CustomCheckboxIcon label={item.label} />}
              isDisabled={isDisabled}
              onChange={e => {
                const newValues = e.target.checked ? [...values, e.target.value] : values.filter(day => day !== e.target.value)
                handleChange(newValues)
              }}
            ></CustomCheckbox>
          )
        })}
      </Box>
    </FormControl>
  )
}
